import { Card } from './../Card';
import './style.css';

export const List = ({listTransactions, setListTransactions, list, setList, isFiltered}) => {

    function deleteCard (transaction) {

        const listFilteredAll = listTransactions.filter((element)=> element.description !== transaction.description);
        setListTransactions(listFilteredAll);
        //MEIO DE TRAZER O STATE COMPLETO SEM USAR O STATE.
        //setListTransactions(element => console.log(element));

        const listFilteredFilter = list.filter((element)=> element.description !== transaction.description);
        setList(listFilteredFilter);

    }

    return (

        <ul className="list">
            {
                    
                isFiltered ? (

                    list.map((transaction, index) => {
                        return <Card transaction={transaction} key={index} deleteCard={deleteCard}/>
                    })

                ) : (

                    listTransactions.map((transaction, index) => {
                        return <Card transaction={transaction} key={index} deleteCard={deleteCard}/>
                    })

                )
                
            }
        </ul>

    );

}